import { PlatformFSContext } from './core/context'
import { type RenameDialogProps, useRenameCore } from './core/hooks/useRename'

export type { RenameDialogProps }

const platformContext = new PlatformFSContext()

export function useRename(domain: number) {
  return useRenameCore(platformContext, domain)
}
